import constants from './constants';
import getApiHeaders from './apiHeaders.js';

/**
 * Fetch chat history for a given chatId
 * @param {string} chatId - The chat ID
 * @returns {Promise<Array>} Array of messages
 */
const fetchChatHistory = async (chatId) => {
    if (!chatId) {
        console.warn('fetchChatHistory: chatId is required');
        return [];
    }

    const url = `${constants.fetchChatById}/${chatId}`;
    
    const response = await fetch(url, {
        method: 'GET',
        headers: getApiHeaders(),
        credentials: 'include'
    });

    const result = await response.json();

    if (!response.ok) {
       response.message = result;
       throw response;
    }
    
    // Convert messages to the format expected by the Chat component
    return (result.messages || []).map(msg => ({
        role: msg.role,
        content: msg.content,
        timestamp: msg.timestamp ? new Date(msg.timestamp) : new Date(),
        references: msg.references,
        action: msg.action,
        actionArguments: msg.actionArguments
    }));
};

export default fetchChatHistory;

